import orderSlice from "../slices/orderSlice";

export const orderReducers = {
  order: orderSlice,
};
